
import noData from '~/components/common/noData.vue'
export default {
  name: 'ErrorPage',
  components: {
    'no-data': noData
  },
  layout: 'error',
  head() {
    return {
      title: this.$t('22205'),
      meta: [{ name: 'description', content: this.$t('22206') }]
    }
  }
  // mounted () {
  //   console.log('layout/error的自定义错误页')
  // }
}
